import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import Header from "../components/ContainerHeader";
import RequestNewReceivedForm from "../components/requestNewReceived/RequestNewReceivedForm";
import Translation from "../Atollon/Translation";

import {
    getProjects,
    getAdminDispatcherOrganizations,
    getTypeBySearch,
    getProviders
} from "../actions/resourceActions";
import { getUser } from "../actions/userActions";
import {DebugElement} from "../Atollon/debug";
import {getNewRequestToFieldFromUrl} from "../Atollon/Request_PreselectFieldsInRequest";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";
import {size} from "lodash";

const RequestNew = ( reactState ) => {

    let {
        history,
        user,
        data,
        location,
        state,
        providers
    } = reactState;

    // console.log('BBB',{reactState,users});
    // debugger;

    let to = data && data.to ? data.to : undefined;
    // Preselect first provider in New request
    if( providers )
    {
        if( size( providers.item ) > 0 )
        {
            to = providers.item[0].identifier;
        }
    }

    let toFromUrl = getNewRequestToFieldFromUrl( location, state );
    if( toFromUrl )
    {
        to = toFromUrl;
    }

    // validate if to is ok ...

  return (
    <div className="flex-col">
      <DebugElement text={"src/containers/RequestNew.js"}/>

      <TouchPageHeader title={Translation('request-new-title','Nový požadavek')} />
      <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      {user && (
        <Card>
          <CardText>
            <RequestNewReceivedForm
              newRequest
              initialValues={{
                requestType: "NEW",
                priceCurrency: "CZK",
                withOrWithoutTax: "WITHOUT_TAX",
                sender: user.identifier,
                to: to,
                customType: "Obecné",
                severity: "5",
                project: "NO_PROJECT",
                messageBody: ""
              }}
              user={user}
              history={history}
              providers={providers}
            />
          </CardText>
        </Card>
      )}
    </div>
  );
};

export default compose(
  connect(state => {
      let { app: { user, data }, resource: { providers } } = state;
      return { user, data, state, providers };
  }, {
    getProjects,
    getAdminDispatcherOrganizations,
    getUser,
    getTypeBySearch,
    getProviders
  }),
  lifecycle({
    async componentWillMount() {
      const {
        getProjects,
        getAdminDispatcherOrganizations,
        getUser,
        getTypeBySearch,
        getProviders
      } = this.props;

      getProjects();
      getAdminDispatcherOrganizations();
      getUser();
      getProviders();
      getTypeBySearch("PERSON,ORGANIZATION"); // search for all available "to" values which can be in form
    }
  })
)(RequestNew);



// WEBPACK FOOTER //
// ./src/pages/RequestNew.js